import { Link } from 'react-router-dom';
import { latestUpdates } from '@/mocks/anime';

export default function LatestUpdate() {
  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8 md:mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2">
              最新更新
            </h2>
            <p className="text-foreground-600 text-sm">实时同步最新动漫章节</p>
          </div>
          <Link
            to="/category/riman"
            className="flex items-center gap-1 text-primary-600 hover:text-primary-700 text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
          >
            全部更新 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="bg-background-100 rounded-xl border border-background-200/70 overflow-hidden">
          <div className="grid grid-cols-1">
            {latestUpdates.map((item, index) => (
              <Link
                key={item.id}
                to={`/article/${item.slug}`}
                className={`flex items-center gap-3 md:gap-4 px-4 md:px-6 py-3 md:py-4 hover:bg-primary-50/50 transition-colors cursor-pointer ${
                  index < latestUpdates.length - 1 ? 'border-b border-background-200/70' : ''
                }`}
              >
                <span className={`w-7 h-7 rounded-full flex items-center justify-center text-xs font-semibold ${
                  index < 3 ? 'bg-accent-500 text-background-50' : 'bg-background-200 text-foreground-600'
                }`}>
                  {index + 1}
                </span>
                <div className="flex-1 min-w-0">
                  <h3 className="text-foreground-950 text-sm md:text-base font-medium truncate hover:text-primary-600 transition-colors">
                    {item.title}
                  </h3>
                </div>
                <span className="text-foreground-500 text-xs whitespace-nowrap">{item.chapter}</span>
                <span className="px-2 py-1 rounded-md bg-background-200 text-foreground-600 text-xs font-medium whitespace-nowrap">
                  {item.category}
                </span>
                <span className="text-foreground-500 text-xs whitespace-nowrap hidden sm:block">
                  {item.updateTime}
                </span>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}